export const HETEROZYGOUS_1 = 1;
export const HETEROZYGOUS_2 = 2;
export const HOMOZYGOUS = 3;
export const SOMATIC = 4;
export const MITO = 5;
export const HOMOZYGOUS_PHASED = 9;
export const HETEROZYGOUS_1_PHASED = 7;
export const HETEROZYGOUS_2_PHASED = 8;
export const NOT_GENOTYPED = -1;
export const HOMO_REF = 0;

export const ZYGOSITY_LABELS = {
  [NOT_GENOTYPED]: "Not Genotyped",
  [HOMO_REF]: "Homozygous Ref",
  [HETEROZYGOUS_1]: "Heterozygous",
  [HOMOZYGOUS]: "Homozygous",
  [SOMATIC]: "Somatic",
  [MITO]: "Mitochondrial",
  [HETEROZYGOUS_1_PHASED]: "Heterozygous 1 (Phased)",
  [HETEROZYGOUS_2_PHASED]: "Heterozygous 2 (Phased)",
  [HOMOZYGOUS_PHASED]: "Homozygous (Phased)",
};

export const ZYGOSITY_TYPE_INDEX = {
  [NOT_GENOTYPED]: NOT_GENOTYPED,
  [HOMO_REF]: HOMO_REF,
  [HETEROZYGOUS_1]: HETEROZYGOUS_1,
  [HETEROZYGOUS_2]: HETEROZYGOUS_1,
  [HOMOZYGOUS]: HOMOZYGOUS,
  [SOMATIC]: SOMATIC,
  [MITO]: MITO,
};

export const ZYGOSITY_TYPE_INDEX_PHASED = {
  [NOT_GENOTYPED]: NOT_GENOTYPED,
  [HOMO_REF]: HOMO_REF,
  [HETEROZYGOUS_1]: HETEROZYGOUS_1_PHASED,
  [HETEROZYGOUS_2]: HETEROZYGOUS_2_PHASED,
  [HOMOZYGOUS]: HOMOZYGOUS_PHASED,
  [SOMATIC]: SOMATIC,
  [MITO]: MITO,
};

export const ACCEPTED_API_ZYGOSITY_TYPES = [
  HETEROZYGOUS_1,
  HETEROZYGOUS_2,
  HOMOZYGOUS,
  SOMATIC,
  MITO,
];
